module.exports = __webpack_public_path__ + "static/img/iPhoneX.ea0f3dea.png";